import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import { useTimeStore } from '@store/common/useTimeStore.js'
import { useOrgInfoQuery } from '@queries/common/orgInfoQuery.js'
import { useTimeQuery } from '@queries/common/timeQuery.js'
import { useEffect, useRef } from 'react'
import { Loading } from '@targetLoading'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const AppDataLoader = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const hasNavigated = useRef(false)

  const params = new URLSearchParams(location.search)
  const bridge = params.get('bridge') === 'Y'
  const hasInitCode = !!params.get('companyCode')
  const isWidgetPath = location.pathname.startsWith('/widgets/')

  const setSections = useOrgInfoStore((s) => s.setSections)
  const setUseType = useOrgInfoStore((s) => s.setUseType)
  const setServerTime = useTimeStore((s) => s.setServerTime)

  const { data: org, isSuccess: orgOK } = useOrgInfoQuery({ enabled: true })
  const { data: time, isSuccess: timeOK } = useTimeQuery({ enabled: true })

  const shouldRedirect = !isWidgetPath && hasInitCode && orgOK && timeOK

  useEffect(() => {
    if (orgOK) {
      const ySections = Object.entries(org?.sections || {})
        .filter(([, v]) => v === 'Y')
        .map(([k]) => k)
      setSections(ySections)

      setUseType(org?.orgCd ?? null)
    }
  }, [orgOK])

  useEffect(() => {
    if (timeOK) {
      setServerTime(time)
    }
  }, [timeOK])

  useEffect(() => {
    if (!hasNavigated.current && !isWidgetPath && hasInitCode && orgOK && timeOK) {
      hasNavigated.current = true
      navigate(bridge ? '/bridge' : '/main', { replace: true })
    }
  }, [orgOK, timeOK, bridge, hasInitCode, isWidgetPath])

  const isLoading = !orgOK || !timeOK
  if (isLoading || shouldRedirect) return <Loading />
  return <Outlet />
}
